import { useContext, useState } from "react"
import { AppContext } from "../App"
import { CDN_URL } from "../Helpers";
import { MdArrowForward } from "react-icons/md";

export default function OneProject({ data }) {

  const appContext = useContext(AppContext);
  const [ isHovered, setIsHovered ] = useState(false);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'projects',
      extraItem: data.uuid,
    })
  }

  return (
    <div 
      className="card border-0 shadow-sm rounded"
      style={{
        height: "420px",
        cursor: "pointer",
        backgroundImage: `url(${CDN_URL + data.coverPhoto})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        overflow: "hidden",
        marginBottom: "24px",
        borderRadius: "16px",
        transition: "transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease",
        transform: isHovered ? "translateY(-8px)" : "translateY(0)",
        boxShadow: "0 10px 30px -10px rgba(0, 0, 0, 0.15)"
      }}
      onClick={view}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      
      {/* Base overlay - always visible for text readability */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(to top, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.7) 30%, rgba(15,23,42,0.35) 60%, rgba(15,23,42,0.15) 85%, transparent 100%)",
          zIndex: 1
        }}
      >
        {/* Static accent bar at bottom - visible by default */}
        <div 
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "4px",
            background: "linear-gradient(90deg, rgba(59,130,246,0.9), rgba(139,92,246,0.9))",
            opacity: 0.9
          }}
        />
      </div>

      {/* Subtle image zoom layer */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${CDN_URL + data.coverPhoto})`,
          backgroundPosition: "center",
          backgroundSize: isHovered ? "110%" : "cover",
          backgroundRepeat: "no-repeat",
          transition: "background-size 0.7s ease",
          zIndex: 0,
        }}
      />

      {/* Content Area */}
      <div 
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "28px",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          gap: "14px"
        }}
      >
        
        {/* Project Title with elegant line clamping */}
        <h6
          style={{
            fontSize: "1.3rem",
            fontWeight: "700",
            color: "#ffffff",
            margin: 0,
            lineHeight: "1.35",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            textShadow: "0 3px 10px rgba(0,0,0,0.5)",
            letterSpacing: "-0.01em"
          }}
          className="mNoMargin"
        >
          {data.title}
        </h6>

        {/* Read More Indicator - always visible, enhanced on hover */}
        <div 
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            paddingTop: "10px",
            borderTop: "1px solid rgba(255,255,255,0.25)",
            transition: "gap 0.3s ease"
          }}
        >
          <span 
            style={{
              fontSize: "0.82rem",
              fontWeight: "600",
              color: "#ffffff",
              letterSpacing: "0.8px",
              textTransform: "uppercase",
              opacity: 0.95
            }}
          >
            View Case Study
          </span>
          <MdArrowForward 
            size={18} 
            color="#ffffff" 
            style={{ 
              transition: "transform 0.3s ease, opacity 0.3s ease",
              transform: isHovered ? "translateX(5px)" : "translateX(0)",
              opacity: isHovered ? 1 : 0.85
            }} 
          />
        </div>

      </div>

      {/* Subtle border glow - visible on hover */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "16px",
          padding: "2px",
          background: isHovered 
            ? "linear-gradient(135deg, rgba(59,130,246,0.5), rgba(139,92,246,0.5))" 
            : "transparent",
          WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          pointerEvents: "none",
          transition: "background 0.3s ease",
          zIndex: 3
        }}
      />
    </div>
  )
}